/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import store from '../../../../../redux/store';
import { Button, PlusIconSVG } from 'cx-ui-components';
import { SelectInputField } from './SelectInputField';

const AddFilterContainer = styled.div`
  display: flex;
  width: 70%;
  font-size: 14px;
  margin-left: 20px;
`;
const Label = styled.label`
  display: inline-block;
  flex-shrink: 0;
  font-size: 14px;
  width: 190px;
  margin-top: 5px;
  padding-right: 10px;
`;
const ActionButton = styled(Button)`
  margin-left: 10px;
  height: 32px;
  padding: 3px 10px;
  background-color: ${(props) => (props.disabled ? '#efefef' : 'inherit')};
`;

export const AddFilter = ({ index, options, disabled, basicQuery }) => (
  <AddFilterContainer>
    <Label>Add a filter</Label>
    <SelectInputField
      name={`basicQuery[${[index]}][filterToAdd]`}
      index={index}
      options={options}
      disabled={disabled}
      data-automation="queueQueryAddFilterList"
    />
    <ActionButton
      type="button"
      onClick={() => {
        store.dispatch({ type: 'ADD_FILTER', index: index, entity: basicQuery.getIn([index, 'filterToAdd']) });
      }}
      title="Add Filter"
      disabled={!basicQuery || !basicQuery.getIn([index, 'filterToAdd'])}
      data-automation="queryFilterAddItem">
      <PlusIconSVG size={12} disabled={disabled} plusIconType={disabled ? 'secondary' : 'primary'} />
    </ActionButton>
  </AddFilterContainer>
);

AddFilter.propTypes = {
  index: PropTypes.number,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  basicQuery: PropTypes.object,
};
